<template>
  <div class="deck-box">
    <DeckList :decks="publicDecks" :linkType="'a'" :linkTarget="'_parent'" />
  </div>
</template>
<script>
import DeckList from '~/components/DeckList'
import { getPublicDecks } from '~/queries/getPublicDecks.gql'

export default {
  layout: 'blank',
  auth: false,
  apollo: {
    publicDecks: {
      query: getPublicDecks,
      variables () {
        const defaultDecks = [391, 222, 53, 385, 630, 235, 1551, 1554, 1728] // 844, 1556
        let decks = []
        let deckList = this.$route.query.decks

        if (deckList) {
          deckList = deckList.split(',').map(id => id * 1)
          decks = decks.concat(deckList)
        }
        return {
          ids: decks.length > 0 ? decks : defaultDecks
        }
      },
      update: data => data.slideDecks
    }
  },
  components: {
    DeckList
  },
  methods: {
  }
}
</script>
<style lang="scss">
.deck-box {
  max-width: 1200px;
  margin: 0 auto;
  justify-content: center;

  .deck-card {
    transition: transform .16s ease;
    // width: 320px;
    &:hover {
      transform: scale(1.03);
    }
  }

  .is-slide {
    font-size: 46px !important;

    // .join-box, .join-info {
    //   display: none;
    // }
  }
}
</style>
